<script>
import Collapse from 'element-ui/lib/collapse';

export default Collapse;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/collapse.css';
</style>
